import React from 'react';
import Countdown from './Countdown';

const Photo = () => {
    const scrollToContent = () => {
        const contentElement = document.getElementById('story');
        if (contentElement) {
            contentElement.scrollIntoView({ 
                behavior: 'smooth'
            });
        }
    };

    return (
        <section className="fullscreen-intro" id="home">
            <div className="fullscreen-content">
                <div className="logo-container">
                    <div className="logo"></div>
                </div>
                <div>
                    <Countdown />
                </div>                
                {/*<div className="scroll-down-indicator" onClick={scrollToContent}>
                    <div className="scroll-arrow"></div>
                    <div className="scroll-text font uppercase">Scorri Giù</div>
                </div>*/}
            </div>
        </section>
    );
};

export default Photo;